
(function() {
  // Add custom code below this line

$( document ).ready(function() {

  $("#shopify-installments-contento").css("display", "none !important");

  $(".sk__inquire-button").bind("click", function(){
    $(".prod_form_overlay").show();
    $(".prod_contact_form").show();
  });
  
    $(".prod_contact_form_close").bind("click", function(){
    $(".prod_form_overlay").hide();
    $(".prod_contact_form").hide();
  });

    $(".prod_form_success_close").bind("click", function(){
    $(".prod_form_success_overlay").hide();
    $(".prod_form_success").hide();
    
  });

  swatch_default = $(".variant_metal_value").text();

 $(".swatch__button").bind("click", function(){
    swatch_default = $(this).find('span.visually-hidden').text();
    $(".variant_metal_value").text(swatch_default);
  });
  
  $(".swatch__button").bind("mouseover", function(){
    title = $(this).find('span.visually-hidden').text();
    $(".variant_metal_value").text(title);
  });
   $(".swatch__button").bind("mouseout", function(){
    $(".variant_metal_value").text(swatch_default);
  });
  
  $(".mobile-footer-expand-button").bind( "click", function() {
		if($(".mobile-footer-expand-icon").css("display") != "none"){
			$(".mobile-footer-expand-button").not(this).each(function(){
				$(this).parent().find("ul").slideUp("fast");
				$(this).parent().find(".icon-vert").show();
			});
  			$(this).parent().find("ul").slideToggle("fast");
      		$(this).parent().find(".icon-vert").toggle();
		}
	});
	
	$(window).on("resize", function(){  
    	if($(".footer-trigger").css("display") == ("none")){
        	$(".footer-nav-ul").hide(); 
        	$(".footer-nav-ul").find(".fa-plus").removeClass( "fa-minus" ); 
    	}else{
    		$(".footer-nav").find("ul").show(); 
        	$(".footer-nav").find(".fa-plus").removeClass( "fa-minus" ); 
    	}
	});
   $("[data-index]").on('change' ,function(){
     SK._handleVariants(variants);
   });
    $(".variant-sku").click(function(){
      var copyText = $(".variant-sku");
      $(".variant-sku").select();
      navigator.clipboard.writeText($(".variant-sku").html());
    });

    if($('#calendly-wrapper').length>0){
      setInterval(function(){console.log($("#calendly-iframe").contents().height())},250)
    }
   if (typeof variants !== 'undefined' && variants.length > 0) {
      SK._handleVariants(variants);
    }

});

  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

var SK = {
  _handleVariants : function(og_variants){
    selected_variant = og_variants.find(function(variant) {
      return variant.id === String(myVariantSku);
    });
    selected_options = selected_variant.options;
    if(selected_variant.inventory > 0){
      selected_inventory = "<span>In Stock:</span> Ships in 1-3 days";
    }else{
      selected_inventory = "<span>Made to Order:</span> Ships in 4-6 weeks";
    }
    $('.product-variant-stock-availability').html(selected_inventory);
    $('.current-variant').html(selected_variant.sku);
    $('.variant-sku').html(selected_variant.sku);
    options_count = $('.selector-wrapper').length;
  
    for(i=0;i<options_count;i++){
      position = i+1;
      
      $('[data-option-position=' + position + ']').find('div.hidden_option_value').each(function(index){
       
        temp_options = Array();
        for(to of selected_options ){
          temp_options.push(to);
        }
        temp_options[i] = $(this).text();

        p_var = og_variants.find(function(variant_2) {
          return variant_2.options.toString() === temp_options.toString();
        });
        
        if(p_var.inventory > 2){
          inventory_level = "In Stock";
        }else if(p_var.inventory == 2){
          inventory_level = "Only 2 left";
        }else if(p_var.inventory == 1){
          inventory_level = "Only 1 left";
        }else{
          inventory_level = "Made to Order";
        }
        $(this).parent().find("div.drop_down_stock_value").html(inventory_level);
 
      });
    }
  }
}
